import WindowsInRowFormMeasurementValues from './WindowsInRowFormMeasurementValues';

export default WindowsInRowFormMeasurementValues;